const Hamburger = () => (
  <svg className="mobile-menu__hamburger" viewBox="0 0 48 48" aria-hidden>
    <g stroke="currentColor" strokeWidth="4">
      <path
        className="mobile-menu__top-bun"
        style={{ transformOrigin: "2.9px 6.3px" }}
        d="m0 4 h48"
      />
      <path
        className="mobile-menu__patty"
        style={{ transformOrigin: "24px 24px" }}
        d="m0 24 h48"
      />
      <path
        className="mobile-menu__bottom-bun"
        style={{ transformOrigin: "2.9px 41.7px" }}
        d="m0 44 h48"
      />
    </g>
  </svg>
);

export default Hamburger;
